declare const Buffer;
import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { pcmEncode, downsampleBuffer } from "./helpers/audioUtils";
import * as createHash from "create-hash";
import { createPresignedURL } from "./helpers/aws-signature-v4"; // to generate our pre-signed URL
import * as marshaller from "@aws-sdk/eventstream-marshaller"; // for converting binary event stream messages to and from JSON
import * as util_utf8_node from "@aws-sdk/util-utf8-node"; // utilities for encoding and decoding UTF8
import MicrophoneStream from "microphone-stream";
import {
  CountdownComponent,
  CountdownConfig,
  CountdownEvent,
} from "ngx-countdown";
import { DomSanitizer } from "@angular/platform-browser";
import { AudioRecordingService } from "@app/core/services/audio-recording.service";

// our converter between binary event streams messages and JSON
const eventStreamMarshaller = new marshaller.EventStreamMarshaller(
  util_utf8_node.toUtf8,
  util_utf8_node.fromUtf8
);

@Component({
  selector: "transcribe-recoder",
  templateUrl: "./transcribe-recoder.component.html",
  styleUrls: ["./transcribe-recoder.component.css"],
})
export class TranscribeRecoderComponent implements OnInit, OnDestroy {
  @ViewChild("countdown", { static: false })
  private countdown: CountdownComponent;
  public blobUrl: any;
  isRecording = false;
  public status: any;
  public isClick: boolean = false;
  public anni: String;
  value = 0;
  public interval: any;

  public config: CountdownConfig = {
    leftTime: 0,
    format: "ss",
  };
  public interval1: any;
  languageCode = "en-US";
  region = "us-east-1";
  sampleRate = 44100;
  transcription = "";
  socket;
  micStream;
  socketError = false;
  transcribeException = false;
  errorText: "";

  public isCountDown: boolean = true;
  public items: any = [];

  @Input() evaluateObj: any;
  @Output() emitFile: any = new EventEmitter<any>();

  resultData: any = {};

  public audioFile: File;

  constructor(
    private audioRecordingService: AudioRecordingService,
    private sanitizer: DomSanitizer
  ) {
    this.audioRecordingService.recordingFailed().subscribe(() => {
      this.isRecording = false;
    });

    // this.audioRecordingService.getRecordedTime().subscribe((time) => {
    //   this.recordedTime = time;
    // });
    this.audioRecordingService.getRecordedBlob().subscribe((data) => {
      console.warn("hello");
      this.blobUrl = this.sanitizer.bypassSecurityTrustUrl(
        URL.createObjectURL(data.blob)
      );
      const file = new File([data.blob], this.evaluateObj.questionId);
      this.audioFile = file;
      console.log(this.audioFile);
    });
  }

  ngOnInit() {
    this.config.leftTime = this.evaluateObj.duration;
    this.isCountDown = true;
    setTimeout(() => {
      this.getCountDown();
    }, 100);
  }

  getCountDown() {
    let countdown = this.evaluateObj.duration;

    this.anni =
      "countdown " + (parseInt(countdown) + 1) + "s linear infinite forwards";
  }

  startRecording() {
    if (this.isMobile()) {
      document.getElementById("my-start-button").onclick = () => {
        this.isShowDialog = false;
        this.startAudioRecording();
        setTimeout(() => {
          this.decrease();
        }, 100);

        navigator.mediaDevices
          .getUserMedia({
            video: false,
            audio: true,
          })
          // ...then we convert the mic stream to binary event stream messages when the promise resolves
          .then(this.streamAudioToWebSocket)
          .catch(function (error) {
            console.log(
              "There was an error streaming your audio to Amazon Transcribe. Please try again.",
              error
            );
          });
      };
    } else {
      navigator.mediaDevices
        .getUserMedia({
          video: false,
          audio: true,
        })
        // ...then we convert the mic stream to binary event stream messages when the promise resolves
        .then(this.streamAudioToWebSocket)
        .catch(function (error) {
          console.log(
            "There was an error streaming your audio to Amazon Transcribe. Please try again.",
            error
          );
        });
    }
  }
  streamAudioToWebSocket = (userMediaStream) => {
    console.warn("here streamAudioToWebSocket");

    //let's get the mic input from the browser, via the microphone-stream module
    this.micStream = new MicrophoneStream();
    this.micStream.setStream(userMediaStream);
    // Pre-signed URLs are a way to authenticate a request (or WebSocket connection, in this case)
    // via Query Parameters. Learn more: https://docs.aws.amazon.com/AmazonS3/latest/API/sigv4-query-string-auth.html
    let url = this.createPresignedUrlNew();
    //open up our WebSocket connection
    this.socket = new WebSocket(url);
    this.socket.binaryType = "arraybuffer";
    // when we get audio data from the mic, send it to the WebSocket if possible
    this.socket.onopen = () => {
      this.micStream.on("data", (rawAudioChunk) => {
        var base64EncodedStr = btoa(
          unescape(encodeURIComponent(rawAudioChunk))
        );
        this.convertBase64toBlob(base64EncodedStr);

        // the audio stream is raw audio bytes. Transcribe expects PCM with additional metadata, encoded as binary
        let binary = this.convertAudioToBinaryMessage(rawAudioChunk);

        if (this.socket.OPEN) this.socket.send(binary);
      });
    };
    // handle messages, errors, and close events
    this.wireSocketEvents();
  };
  createPresignedUrlNew = () => {
    let endpoint = "transcribestreaming." + this.region + ".amazonaws.com:8443";
    // get a preauthenticated URL that we can use to establish our WebSocket
    return createPresignedURL(
      "GET",
      endpoint,
      "/stream-transcription-websocket",
      "transcribe",
      createHash("sha256").update("", "utf8").digest("hex"),
      {
        key: "AKIA37MQOV7WL77H7AM5",
        secret: "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",
        protocol: "wss",
        expires: 120,
        region: "us-east-1",
        query:
          "language-code=" +
          this.languageCode +
          "&media-encoding=pcm&sample-rate=" +
          this.sampleRate,
      }
    );
  };
  getAudioEventMessage = (buffer) => {
    // wrap the audio data in a JSON envelope
    return {
      headers: {
        ":message-type": {
          type: "string",
          value: "event",
        },
        ":event-type": {
          type: "string",
          value: "AudioEvent",
        },
      },
      body: buffer,
    };
  };
  convertAudioToBinaryMessage = (audioChunk) => {
    let raw = MicrophoneStream.toRaw(audioChunk);

    if (raw == null) return;

    // downsample and convert the raw audio bytes to PCM
    let downsampledBuffer = downsampleBuffer(raw, this.sampleRate);
    let pcmEncodedBuffer = pcmEncode(downsampledBuffer);

    // add the right JSON headers and structure to the message
    let audioEventMessage = this.getAudioEventMessage(
      Buffer.from(pcmEncodedBuffer)
    );

    //convert the JSON object + headers into a binary event stream message
    // @ts-ignore
    let binary = eventStreamMarshaller.marshall(audioEventMessage);

    return binary;
  };

  closeSocket = () => {
    this.stopRecording();
    if (this.socket.readyState == WebSocket.OPEN && !this.isClick) {
      this.micStream.stop();
      // Send an empty frame so that Transcribe initiates a closure of the WebSocket after submitting all transcripts
      let emptyMessage = this.getAudioEventMessage(Buffer.from(new Buffer([])));
      // @ts-ignore
      let emptyBuffer = eventStreamMarshaller.marshall(emptyMessage);
      this.socket.send(emptyBuffer);
      this.isClick = true;
    }
  };

  handleEventStreamMessage = (messageJson) => {
    let results = messageJson.Transcript.Results;
    if (results.length > 0) {
      if (results[0].Alternatives.length > 0) {
        let transcript = results[0].Alternatives[0].Transcript;

        // fix encoding for accented characters
        transcript = decodeURIComponent(escape(transcript));

        // update the textarea with the latest result
        console.error("transcript", transcript);
        console.error(results);
        // if this transcript segment is final, add it to the overall transcription
        if (!results[0].IsPartial) {
          if (this.isClick) {
            console.warn("here stop");
            this.items = results;
          }
          //scroll the textarea down
          this.transcription += transcript + "\n";
        }
      }
    }
  };
  public isRealClose: boolean = false;
  wireSocketEvents = () => {
    // handle inbound messages from Amazon Transcribe
    this.socket.onmessage = (message) => {
      //convert the binary event stream message to JSON
      let messageWrapper = eventStreamMarshaller.unmarshall(
        Buffer(message.data)
      );
      let messageBody = JSON.parse(
        String.fromCharCode.apply(String, messageWrapper.body)
      );
      if (messageWrapper.headers[":message-type"].value === "event") {
        this.handleEventStreamMessage(messageBody);
      } else {
        this.transcribeException = true;
        // toggleStartStop();
      }
    };

    this.socket.onerror = function () {
      this.socketError = true;
      // toggleStartStop();
    };

    this.socket.onclose = (closeEvent) => {
      this.micStream.stop();
      console.error("hello close socket");
      this.resultData.transcript = this.transcription;
      this.resultData.items = this.items;
      this.resultData.isNoEvaluate = false;
      this.resultData.isTimmer = this.isCountDown;
      this.resultData.recoderStatus = "end";
      this.resultData.blobUrl = this.blobUrl;
      this.resultData.file = this.audioFile;
      this.emitFile.emit(this.resultData);

      // the close event immediately follows the error event; only handle one.
      if (!this.socketError && !this.transcribeException) {
        if (closeEvent.code != 1000) {
          console.log("error" + closeEvent.reason);
        }
        // toggleStartStop();
      }
    };
  };

  handleEvent(e: CountdownEvent) {
    if (e.action === "done") this.timmerEnd(false);
  }

  public isShowDialog: boolean = false;
  timmerEnd(e: boolean) {
    this.countdown.stop();
    this.isCountDown = e;
    if (this.status != "started") {
      this.status = "start";
      setTimeout(() => {
        if (
          this.evaluateObj.questionType != "S002" &&
          this.evaluateObj.questionType != "S005"
        )
          this.playAudioBeep();
        else {
          this.checkDevice();
        }
      });
    }
    clearInterval(this.interval1);
  }

  checkDevice() {
    if (!this.isMobile()) {
      this.startRecording();
      this.startAudioRecording();
      setTimeout(() => {
        this.decrease();
      }, 100);
    } else {
      this.isShowDialog = true;
      setTimeout(() => {
        this.startRecording();
      }, 200);
    }
  }
  playAudioBeep() {
    this.checkDevice();
    let audio = new Audio();
    audio.src = "assets/audio/SpeakingBeep.wav";
    audio.load();
    audio.play();
  }

  decrease() {
    this.status = "started";
    if (this.value == 0) {
      this.value = 1;
      var elem = document.getElementById("myBar");
      var width = 1;
      this.interval = setInterval(() => {
        if (width >= 100) {
          clearInterval(this.interval);
          this.value = 0;
          // this.isClick=true;
          this.onEnd();
        } else {
          width++;
          elem.style.width = width + "%";
        }
      }, this.evaluateObj.recordDuration * 10);
    }
  }

  convertBase64toBlob(b64: string) {
    const byteCharacters = atob(b64);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: "audio/mp3" });
    this.blobUrl = this.sanitizer.bypassSecurityTrustUrl(
      URL.createObjectURL(blob)
    );
    // this.audioFile = new File([blob], this.evaluateObj.questionId);
  }

  onRestart() {
    clearInterval(this.interval1);
    clearInterval(this.interval);
    if (this.socket) this.closeSocket();
    this.isCountDown = true;
    this.status = undefined;
    this.anni = undefined;
    setTimeout(() => {
      this.getCountDown();
    }, 100);
  }

  onEnd() {
    clearInterval(this.interval1);
    clearInterval(this.interval);
    if (!this.isClick) {
      this.closeSocket();
    }
    // this.closeSocket();

    // this.stopRecording();
    this.isCountDown = undefined;
    this.status = undefined;
    this.anni = undefined;
  }

  // start here recording
  startAudioRecording() {
    if (!this.isRecording) {
      this.isRecording = true;
      this.audioRecordingService.startRecording();
    }
  }

  abortRecording() {
    if (this.isRecording) {
      this.isRecording = false;
      this.audioRecordingService.abortRecording();
    }
  }

  stopRecording() {
    if (this.isRecording) {
      this.audioRecordingService.stopRecording(this.evaluateObj.questionId);
      this.isRecording = false;
    }
  }

  clearRecordedData() {
    this.blobUrl = null;
  }
  // end here recording
  isMobile() {
    try {
      document.createEvent("TouchEvent");
      return true;
    } catch (e) {
      return false;
    }
  }
  ngOnDestroy(): void {
    if (this.socket) this.closeSocket();
    this.stopRecording();
  }
}
